import { render, staticRenderFns } from "./DisabledRating.vue?vue&type=template&id=c2fc14cc"
import script from "./DisabledRating.vue?vue&type=script&lang=js"
export * from "./DisabledRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports